import { memo } from 'react';

function ActionBar(props) {
  const { children } = props;
  return <div className="flex flex-row md:my-4 flex-wrap">{children}</div>;
}

export default memo(ActionBar);
